import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { trpc } from '@tg/app-core';
import { dayHas } from '@tg/domain';
import { MONTHS_N, RU, dowMon, monthEnd, shiftMonth, today } from './dates';
import type { Who } from './Constructor';

/* Дата в заголовке конструктора (openDatePick): месяц клиента или группы, точки — дни с тренировками */
export function DatePick({ who, date, anchor, onPick, onClose }: { who: Who; date: string; anchor: HTMLElement; onPick: (d: string) => void; onClose: () => void }) {
  const [month, setMonth] = useState(date.slice(0, 7));
  const box = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState({ left: 0, top: 0 });
  const q = trpc.trainer.days.useQuery({ who, from: month + '-01', to: monthEnd(month + '-01') });
  const has = new Map((q.data || []).filter((d) => dayHas(d.content)).map((d) => [d.date, d.status === 'published' ? 'pub' : 'draft']));
  const [y, m] = month.split('-').map(Number);
  const lead = dowMon(month + '-01');
  const n = +monthEnd(month + '-01').slice(8);
  const t = today();
  useLayoutEffect(() => {
    const r = anchor.getBoundingClientRect();
    const w = box.current?.offsetWidth || 340;
    setPos({ left: Math.max(12, Math.min(r.left, document.documentElement.clientWidth - w - 12)), top: window.scrollY + r.bottom + 6 });
    const out = (e: MouseEvent) => box.current && !box.current.contains(e.target as Node) && !anchor.contains(e.target as Node) && onClose();
    const key = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    setTimeout(() => document.addEventListener('mousedown', out));
    document.addEventListener('keydown', key);
    return () => (document.removeEventListener('mousedown', out), document.removeEventListener('keydown', key));
  }, []);
  return createPortal(
    <div ref={box} className="sug dpk" style={pos}>
      <div className="mcal">
        <div className="mcal-h">
          <button data-dpm="-1" title="Предыдущий месяц" onClick={() => setMonth(shiftMonth(month, -1))}>
            ‹
          </button>
          <b>
            {MONTHS_N[m - 1]} {y}
          </b>
          <button data-dpm="1" title="Следующий месяц" onClick={() => setMonth(shiftMonth(month, 1))}>
            ›
          </button>
        </div>
        <div className="mcal-g">
          {RU.map((w) => (
            <s key={w}>{w}</s>
          ))}
          {Array.from({ length: lead }, (_, k) => (
            <span key={'p' + k} className="pad"></span>
          ))}
          {Array.from({ length: n }, (_, k) => {
            const d = month + '-' + String(k + 1).padStart(2, '0');
            const st = has.get(d);
            return (
              <button key={d} className={[st ? 'has ' + st : '', d === date ? 'on' : '', d === t ? 'today' : ''].filter(Boolean).join(' ')} data-dpk={d} onClick={() => onPick(d)}>
                {k + 1}
                {st && <i></i>}
              </button>
            );
          })}
        </div>
      </div>
      <div className="dpk-f">
        <span>
          <i className="pub"></i>опубликована
        </span>
        <span>
          <i className="draft"></i>черновик
        </span>
        <span className="sp"></span>
        <span>с точкой — откроется на правку</span>
      </div>
    </div>,
    document.body,
  );
}
